import { type ReactElement } from "react";
import { Trans } from "react-i18next";

import type { TranslationKeyAndOptions } from "@thalamos/vision-common";

export type TranslationProps = TranslationKeyAndOptions & {
  components?: { readonly [tagName: string]: ReactElement };
};

export const Translation = ({
  translationKey,
  translationOptions,
  components = {},
}: TranslationProps) => (
  <Trans
    i18nKey={translationKey}
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
    tOptions={translationOptions as any}
    components={{
      ...components,
      underline: <u />,
      bold: <strong />,
      ul: <ul />,
      li: <li />,
    }}
  />
);
